module.exports = __webpack_public_path__ + "img/traveler-background-maritime.f9bd55b3.svg";